import React from 'react'
import {
  Outlet
}
from 'react-router-dom'

/**
 * App configuration
 */
import app from '@config/application'

/**
 * Helpers and Interface
 */
import {pure} from '@react/store'
import {getCookies} from '@helpers/common'
import {DefaultComponentProps} from '@interface/common'

/**
 * Components
 */
import Panel from '@react/panel'


const admins = [
  'Administrator',
  'Organization Administrator'
]


export default pure(({user, auth, modal, navigation}: DefaultComponentProps) => {
  
  React.useEffect(() => {
    const logged = getCookies('logged')
    console.log(logged)
    if(!logged) {
      // auth.logout()
    }
    else {
      setInterval(() => {
        const logged = getCookies('logged')
        
        if(!logged && location.pathname.match(/\/office\//)) {
          modal.open({
            name: 'sessionExpired'
          })
        }
      }, 10000)
    }
  }, [])


  if(!user.uid || isNotAuthorized(user)) {
    navigation.redirect('/')
    return null
  }

  return (
    <React.Fragment>
      <Panel/>
      <div id="content">
        <Outlet/>
      </div>
    </React.Fragment>
  )
})


/**
 * Check if user is not authorized on specific pages
 */
function isNotAuthorized(user:any) {
  const arr:any = []
  const name = location.pathname.split('/').at(-1)

  const find = function(items:any) {
    for(var item of items) {
      if(item.group) {
        find(item.group)
      }
      else {
        if(item.auth.length === 1 && item.auth[0] === 'Administrator') {
          arr.push(item.name.toLowerCase())
        }
      }
    }
  }
  find(app.navigation)


  if(arr.includes(name) && (user.organization && !admins.includes(user.organization.role))) {
    return true
  }
  return false
}